import React, { useState } from "react";
import "./Form.scss";
import { Eye, EyeOff } from "react-feather";
import { useActions } from "../../../hooks/useActions";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import BeelineLogo from "./beeline_logo.png";

const Form = (): JSX.Element => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { error } = useTypeSelector((state) => state.user);
  const [showPassword, setShowPassword] = useState(false);
  const { getUserToken } = useActions();
  const formSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (email !== "" && password !== "") {
      getUserToken(email, password);
    }
  };

  return (
    <div className="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div className="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h3 className="card-title mb-1">MLaaS</h3>
        <h1 className="card-title font-weight-bold mb-1">МРТ</h1>
        <p className="card-text mt-4 mb-2">
          Пожалуйста, авторизуйтесь чтобы продолжить работу в системе
        </p>
        <form
          className="auth-login-form mt-2"
          method="POST"
          onSubmit={(e) => formSubmit(e)}
        >
          <div className="form-group">
            <input
              className={"form-control" + (error ? " is-invalid" : "")}
              id="login-email"
              type="text"
              name="login-email"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email"
              aria-describedby="login-email"
            />
          </div>
          <div className="form-group">
            <div className="input-group input-group-merge form-password-toggle">
              <input
                className={
                  "form-control form-control-merge" +
                  (error ? " is-invalid" : "")
                }
                id="login-password"
                type={!showPassword ? "password" : "text"}
                autoComplete="current-password"
                name="login-password"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="············"
                aria-describedby="login-password"
              />
              <div className="input-group-append">
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  className="input-group-text cursor-pointer"
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </span>
              </div>
            </div>
          </div>
          <div className="form-group">
            <button
              className="mt-3 pt-2 pb-2 pl-5 pr-5 btn bg-beeline-color float-right login-button"
              type="submit"
            >
              Войти
            </button>
          </div>
        </form>
      </div>
      <div className="position-absolute logo-bottom">
        <img alt="Beeline logo" src={BeelineLogo} width={120} />
      </div>
    </div>
  );
};

export default Form;
